import { define } from './theme.js';
class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.url || this.querySelector('[data-recommendation-list]')) return;
    this.observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.load(); }
    }, { rootMargin: '200px' });
    this.observer.observe(this);
  }
  disconnectedCallback() { this.observer?.disconnect(); this.request?.abort(); }
  async load() {
    this.request = new AbortController();
    try {
      const response = await fetch(this.dataset.url, { signal: this.request.signal });
      if (!response.ok) return;
      const source = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('product-recommendations');
      if (!source || !this.isConnected) return;
      const excluded = new Set((this.dataset.exclude || '').split(','));
      source.querySelectorAll('[data-recommendation-product]').forEach(item => { if (excluded.has(item.dataset.recommendationProduct)) item.remove(); });
      if (!source.querySelector('[data-recommendation-product]')) { this.hidden = true; return; }
      this.replaceChildren(...source.childNodes);
      await import('./quick-add.js');
    } catch (error) { if (error.name !== 'AbortError') this.hidden = true; }
  }
}
define('product-recommendations', ProductRecommendations);
